import { render, staticRenderFns } from "./ItemsEntity.vue?vue&type=template&id=5e13b2c2&"
import script from "./ItemsEntity.vue?vue&type=script&lang=js&"
export * from "./ItemsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports